import styled, { css } from "styled-components";
import { IDropContainerProps } from "../../../interfaces/file";

export const Container = styled.div``;

export const Wrapper = styled.div`
  padding: 1rem;
  background: var(--file-upload-background);
  border-radius: 5px;
  width: 100%;
  max-width: 27rem;
`;

const dragActive = css`
  border-color: var(--file-upload-active);
  color: var(--file-upload-active);
`;

const dragReject = css`
  border-color: var(--file-upload-reject);
  color: var(--file-upload-reject);
`;

export const DropContainer = styled.div<IDropContainerProps>`
  border: var(--file-upload-border);
  padding: 2rem 2.5rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: height 0.2s ease;

  p {
    font-size: 1.5rem;
    text-align: center;
    margin: 0;
  }

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.6;
    `}

  ${({ isDragActive }) => isDragActive && dragActive}
  ${({ isDragReject }) => isDragReject && dragReject}
`;
